import React from "react";
                  
export function CreateInvoice() {
    return <h1>Hello!</h1>
}